const msaPage1 = JSON.stringify(`MASTER SUBCONTRACT AGREEMENT
This Master Subcontract Agreement is made and entered this ____ day of __________________ by and between Transblue, LLC, a Nevada limited liability company (hereinafter called “WE,” “OUR,” or “US”) and

SUBCONTRACTOR or SUPPLIER:_____________________________
Contact Person:_______________________________
Office Phone: ________________________________
Address: _____________________________________
Cell Phone: ____________________________________
Fax:_____________________________________
Bond Registration # ___________________________

hereinafter called “YOU.”

We have or may utilize Your services for various projects. The parties desire to enter into a Master Subcontract Agreement (“MSA”) that applies to all projects We contract with You, including any current projects in process. The actual work (“Work”) for each project governed by this MSA will be specified and authorized pursuant to a separately executed Scope of Work (“SOW”) that specifies:

(a) the project name and address,
(b) name of the project owner,
(c) work to be performed,
(d) contract price or rates, and
(e) other information and terms applicable to that particular project.


(All work with a SOW is referred to herein as a “Project”). Unless the terms of the SOW expressly state otherwise, the terms of this MSA are binding and applicable to all Work or Project(s) You perform.

In this MSA, and in addition to other obligations, You will agree to the following:

1. You receive payment after we receive payment. (¶3.1)
2. All changes must be in writing signed by both parties. (¶4)
3. Time is of the essence. (¶5.3)


Now, therefore, for good and valuable consideration, the receipt and adequacy of which are hereby acknowledged, the parties agree as follows:
`)

export default msaPage1;